import styled from 'styled-components'
import { FooterStyleType } from 'src/types/type'
import { generateMedia } from 'styled-media-query'

const customMedia = generateMedia({
  main1: '1920px',
  main1_2: '1750px',
  main1_3: '1500px',
  tablet: '1200px',
  tablet_cut_line: '600px',
  modal: '432px',
  mobile: '360px',
  main6: '768px',
  tabl4et: '1199px'
})

const BannerWrap = styled.div`
  width: 100%;

  > img {
    max-width: 492px;
    width: 100%;
    display: block;
  }
`

const FooterWrap = styled.div<FooterStyleType>`
  margin-top: 15px;

  > section {
    background-color: ${props => props.backgroundColor};
    color: ${props => props.color};
    width: 100%;

    > div {
      width: 95%;
      padding: 10px 0;
      outline: none;
      font-size: 10.67px;

      > ul {
        padding: 0 0 0 20px;
        
        .important {
           font-weight: bold;
        }
      }

      @media all and (max-width: 492px) {
        width: 90%;
      }
    }
  }
`

const TermsModalWrap = styled.div<{ active: boolean }>`
  display: inline-block;
  margin: 16px;

  > h2 {
    margin: 16px 0;
  }

  > pre {
    white-space: pre-line;
  }
`
const PageCallingWrap = styled.div<{ active: boolean }>`
  display: ${(props) => (props.active ? 'display' : 'none')};
  width: 100%;
  height: 100vh;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.8);
  top: 0;
  left: 0;
  position: fixed;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 300px;
    height: 206px;
    display: block;
    background-color: white;
    border-radius: 10px;

    > p {
      font-size: 16px;
      padding-top: 20px;
      font-weight: bold;
      text-align: center;
    }

    > img {
      display: flex;
      margin: 15px auto 0 auto;
    }
  }
`
export const PopupLayer = styled.div`
  padding: 20px;
`
export const MVNOPopupWrap = styled.div`
  margin: 6px 0 6px 0;
  .close-btn {
    width: 20px;
    position: absolute;
    top: 16px;
    right: 16px;
  }
  .top {
    text-align: center;
    
    .description {
      font-family: Noto Sans KR;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      text-align: center;
      margin-bottom: 6px;

    }
    .title {
      margin: 0px;
      font-family: Noto Sans KR;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
  }
}
  .terms-wrap {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    height: 136px;
    border: 1px solid rgb(179, 179, 179);
    border-radius: 5px;
    margin: 16px 0 16px 0;
    overflow: hidden;
  }
  .terms-contents-wrap{
     width: calc(100% - 109px);
     height:calc(100% - 1px);
     box-sizing: border-box;
     padding: 12px;
     overflow-y: auto;
     text-align: left;
     background: #f9f9f9;

      //Scrollbar Custom
     ::-webkit-scrollbar {
       width: 1rem;
       position:absolute;
     }
  
     ::-webkit-scrollbar-track {
       box-shadow: none;
       background-color: transparent;
     }
  
     ::-webkit-scrollbar-thumb {
       background-color: #d9d9d9;
        border-radius: 1.25rem;
        border: 0.375rem solid transparent;
       background-clip: content-box;
     }
   }
  
    .terms-contents{
      font-size: 10px;
      margin: 0;
      white-space: break-spaces;
     
    }
    #terms-check {
      display: none;
    }
    .check-wrap{
      width: 109px;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: center;
      > label { 
        > p {
          font-size:15px;
        }
      }
  }
  button {
    width: 100%;
  }
`;

export const TermsCheckBox = styled.label<{ isChecked: boolean }>`
    display: inline-block;
    position: relative;
    
    p {
      margin: 0px;
      font-family: Noto Sans KR;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      white-space: break-spaces;
    }

    .icon {
      display: inline-block;
        width: 24px;
        height: 24px;
        position: relative;
        margin-top: 6px;
        border-radius: 50%;
        border: 1px solid transparent;
        background-color: ${(props) => (props.isChecked ? '#CF3540' : '#ced6e3')};
        @media all and (max-width: 1200px) {
            width: 24px;
            height: 24px;
        }
        ${(props) =>
          props.isChecked
            ? `
                border-color: #CF3540;
              `
            : `
                border-color: #D9D9D9;
              `}
        &:after {
            content: "";
            display: block;
            width: 10px;
            height: 6px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin: -6px 0 0 -6px;
            border-left: 2px solid transparent;
            border-bottom: 2px solid transparent;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            ${(props) =>
              props.isChecked
                ? `
                    border-color: #FFFFFF;
                  `
                : `
                    border-color: #FFFFFF;
                  `}
        }
`;

export const ModalWrap = styled.div<{ toggle: any, zIndex: number, width?: string }>`
  z-index: ${(props) => (props.zIndex)};
  width: ${(props) => (props.width)};
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${(props) => (props.toggle ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
`



export const ModalBox = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  background: white;
  width: 360px;
  height: auto;
  box-shadow: 0 2px 5px rgba(42, 41, 46, 0.16);
  border-radius: 10px;
  text-align: center;
  ${customMedia.lessThan('modal')`
     min-width: 328px;
     width: 92.5%;
  `}
  ${customMedia.lessThan('tablet_cut_line')`
     margin: 0 auto;
  `}
  > h4 {
    margin: 0;
    font-weight: 700;
    font-size: 16px;
    color: black;
  }

  > p {
    margin: 20px 0;
  }

  > img {
    z-index: 1;
    max-width: 280px;

    margin-left: -20px;
  }
`
export { PageCallingWrap, TermsModalWrap, BannerWrap, FooterWrap }
